export default {
    setProductosArray(state, prods) {
        state.productosArray = prods;
    },
    resetProductos(state) {
        state.productosArray = []
    },
    setViendoOpciones(state, v) {
        state.viendoOpciones = v;
    },
    setProductoEditando(state, p) {
        state.productoEditando = p;
    },
    setOpcionesEditadas(state, ops) {
        state.opcionesEditadas = ops;
    },
    setCategoriaFiltrar(state, c) {
        state.categoriaFiltrar = c;
    },
    setGruposModificadores(state, g) {
        state.gruposModificadores = g
    },
    setModificadores(state, m) {
        state.modificadores = m
    },
    setTarifas(state, t) {
        state.tarifas = t
    },
    setBusqueda(state, s) {
        state.busqueda = s;
    },
    setBusquedaMenu(state, s) {
        state.busquedaMenu = s;
    },
    setMenus(state, a) {
        state.menus = a
    }

}